import componentKeys from "@/helpers/wc/componentKeys";
import defaultPosition from "@/helpers/wc/positionSettings";

export const graveyardQrSettings = {
  title: 'Graveyard QR',
  [componentKeys.name]: 'graveyardQrBase',
  [componentKeys.styles]: {
    ...defaultPosition,
    [componentKeys.opacity]: "1",
  },
  [componentKeys.properties]: {
    cemeteryNo: '01',
    entrance: '1',
  }
};
